<template>
    <div>
        <p class="nodata ben-color-999 ben-align-center" :style="noDataStyle">{{dataTitle}}</p>
    </div>
</template>
<script>
import "./../assets/index.css"
export default {
    props: {
        dataTitle : {
            type : String,
            default : "没有数据"
        },
        noDataStyle : {
            type : Object
        }
    },
    data () {
        return {
        
        }
    },
    created () {
        
    },
    
}

</script>


<style lang='scss' scoped>
.nodata{
    margin-top: 30px;
}
</style>


// WEBPACK FOOTER //
// src/view/procurement/components/noData.vue